<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app, html, body {
  height: 100%;
  margin: 0;
  padding: 0}
</style>



// WEBPACK FOOTER //
// src/App.vue